const initialState = {
    batchesPending: false,
    batches: [],
    listPending: false,
    notices: [],
    users: [],
    sendPending: false,
    sendResult: null,
    previewPending: false,
    preview: null,
    changePending: false,
    eventsPending: false,
    events: [],
    eventsTotalPages: 0,
    error: null
};

const replaceNotice = (notices, updated) =>
    notices.map(notice => (notice.id === updated.id ? updated : notice));

const userNoticesReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'USER_NOTICES_CLEAR_STATUS':
            return {...state, error: null, sendResult: null, preview: null};
        case 'USER_NOTICES_BATCHES_PENDING':
            return {...state, batchesPending: true, error: null};
        case 'USER_NOTICES_BATCHES_SUCCESS':
            return {...state, batchesPending: false, batches: action.batches};
        case 'USER_NOTICES_BATCHES_ERROR':
            return {...state, batchesPending: false, error: action.error};
        case 'USER_NOTICES_LIST_PENDING':
            return {...state, listPending: true, error: null};
        case 'USER_NOTICES_LIST_SUCCESS':
            return {...state, listPending: false, notices: action.notices};
        case 'USER_NOTICES_LIST_ERROR':
            return {...state, listPending: false, error: action.error};
        case 'USER_NOTICES_LIST_CLEAR':
            return {...state, notices: []};
        case 'USER_NOTICES_USERS_SUCCESS':
            return {...state, users: action.users};
        case 'USER_NOTICES_USERS_ERROR':
            return {...state, users: [], error: action.error};
        case 'USER_NOTICES_SEND_PENDING':
            return {...state, sendPending: true, sendResult: null, error: null};
        case 'USER_NOTICES_SEND_SUCCESS':
            return {...state, sendPending: false, sendResult: action.result};
        case 'USER_NOTICES_SEND_ERROR':
            return {...state, sendPending: false, error: action.error};
        case 'USER_NOTICES_PREVIEW_PENDING':
            return {...state, previewPending: true, preview: null, error: null};
        case 'USER_NOTICES_PREVIEW_SUCCESS':
            return {...state, previewPending: false, preview: action.preview};
        case 'USER_NOTICES_PREVIEW_ERROR':
            return {...state, previewPending: false, error: action.error};
        case 'USER_NOTICES_CHANGE_PENDING':
            return {...state, changePending: true, error: null};
        case 'USER_NOTICES_CHANGE_SUCCESS':
            return {...state, changePending: false, notices: replaceNotice(state.notices, action.notice)};
        case 'USER_NOTICES_CHANGE_ERROR':
            return {...state, changePending: false, error: action.error};
        case 'USER_NOTICES_STOP_BATCH_SUCCESS':
            return {...state, changePending: false};
        case 'USER_NOTICES_EVENTS_PENDING':
            return {...state, eventsPending: true, events: action.page === 0 ? [] : state.events};
        case 'USER_NOTICES_EVENTS_SUCCESS':
            return {
                ...state,
                eventsPending: false,
                events: action.page === 0 ? action.events.content : [...state.events, ...action.events.content],
                eventsTotalPages: action.events.totalPages
            };
        case 'USER_NOTICES_EVENTS_ERROR':
            return {...state, eventsPending: false, error: action.error};
        default:
            return state;
    }
};

export default userNoticesReducer;
